import { makeSelectors } from '@utils/css';
import { wrapper, root } from './_component.style.js';

const selectors = makeSelectors({
  root: root,
  wrapper: wrapper
});

export { selectors };
//# sourceMappingURL=_component.selectors.js.map
